<template>
  <a-modal
    :open="open"
    :title="title"
    centered
    width="650px"
    :mask-closable="false"
    wrapClassName="create-portfolio-modal"
    :body-style="{ paddingLeft: '40px', paddingRight: '40px' }"
    @cancel="handleVerifyChanges"
  >
    <a-tabs :activeKey="activeTabKey" @update:activeKey="handleTabChange">
      <!-- General config -->
      <a-tab-pane :key="1" tab="General">
        <a-form class="form" layout="vertical" ref="formRef" :model="formState" :rules="rules">
          <a-row :gutter="24">
            <a-col :span="customer.type_business === TypeBusiness.contactCenter ? '12' : '24'">
              <a-form-item name="name" label="Nombre de la campaña">
                <a-input
                  v-model:value="formState.name"
                  placeholder="Escribir nombre de la campaña"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="customer.type_business === TypeBusiness.contactCenter">
              <EntityPicker
                v-model:value="formState.entity"
                :disabled="props.isEdit"
                label="Empresa"
                default-behavior
                :show-all="false"
                triggerNode
              />
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item name="operation_type" label="Tipo de Operación">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.operation_type"
                  placeholder="Seleccionar tipo de operación"
                >
                  <a-select-option :value="OperationType.ClientAttention">
                    Atencion al Cliente
                  </a-select-option>
                  <a-select-option :value="OperationType.Marketing">
                    Telemarketing
                  </a-select-option>
                  <a-select-option :value="OperationType.Sells"> Televentas </a-select-option>
                  <a-select-option :value="OperationType.Collection"> Cobranzas </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24" v-if="formState.operation_type === OperationType.Collection">
            <hr />

            <a-col :span="24">
              <a-form-item
                name="pdp_type"
                label="Tipo de asociación a formularios en tipificaciones"
              >
                <div class="group__info">
                  <span>
                    <InfoCircleOutlined />
                  </span>
                  <p class="info">
                    Se debe tomar en cuenta que esta configuración afectará solo a algunos
                    formularios.
                  </p>
                </div>

                <a-radio-group v-model:value="formState.pdp_type">
                  <a-radio :value="1" :style="radioStyle">
                    Por contacto

                    <a-tooltip>
                      <template #title>
                        El usuario podrá completar el formulario por contacto.
                      </template>
                      <InfoCircleOutlined />
                    </a-tooltip>
                  </a-radio>

                  <a-radio :value="2" :style="radioStyle">
                    Por producto

                    <a-tooltip>
                      <template #title>
                        El usuario podrá completar el formulario que será registrado por cada
                        producto.
                      </template>
                      <InfoCircleOutlined />
                    </a-tooltip>
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

          <hr />

          <a-row :gutter="20">
            <a-col :span="24">
              <a-form-item name="schedule_management_type" label="Configuración de recordatorio">
                <div class="group__info">
                  <!-- <span>
                    <InfoCircleOutlined />
                  </span> -->
                  <p class="info">
                    Tipo de recordatorio que tendrán los usuarios para volverse a contactar con un
                    contacto.
                  </p>
                </div>

                <a-radio-group v-model:value="formState.schedule_management_type">
                  <a-radio :value="1" :style="radioStyle">
                    Notificación simple
                    <a-tooltip>
                      <template v-slot:title>
                        Los usuarios recibirán una notificación para marcar al contacto de forma
                        manual
                      </template>
                      <InfoCircleOutlined />
                    </a-tooltip>
                  </a-radio>
                  <a-radio :value="2" :style="radioStyle">
                    Caída automática
                    <a-tooltip>
                      <template v-slot:title>
                        Se marcará automáticamente al contacto sin intervención del usuario y se le
                        asignará la llamada
                      </template>
                      <InfoCircleOutlined />
                    </a-tooltip>
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

          <hr />

          <a-row :gutter="24" v-if="!customer.enable_bases">
            <a-col :span="24">
              <a-form-item
                name="enable_still_tipificactions"
                label="Regeneración de contactos al finalizar el mes"
              >
                <div class="group__info">
                  <!-- <span>
                    <InfoCircleOutlined />
                  </span> -->
                  <p class="info">
                    Las campañas se mantendrán activas cada mes y los contactos gestionados
                    mantendrán sus resultados o no, dependiendo de tu siguiente elección:
                  </p>
                </div>
                <a-radio-group v-model:value="formState.enable_still_tipificactions">
                  <a-radio :value="false" :style="radioStyle" class="separator__radio">
                    Regenerar contactos en blanco (Sin resultados generados por tipificaciones)
                  </a-radio>
                  <div class="separator__group"></div>
                  <a-radio :value="true" :style="radioStyle" class="separator__radio">
                    Regenerar contactos manteniendo los resultados generados por tipificaciones
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

          <hr />

          <a-form-item
            name="assignment_type"
            label="Asignación automática de los contactos por gestión"
          >
            <div class="group__info">
              <!-- <span>
                <InfoCircleOutlined />
              </span> -->
              <p class="info">
                Personaliza la asignación de contactos según su gestión, permitiendo a los usuarios
                atender sus contactos asignados en futuras gestiones y crear estrategias enfocadas
                en ello.
              </p>
            </div>

            <a-radio-group v-model:value="formState.assignment_type">
              <a-radio :value="AssignmentType.None" :style="radioStyle">
                {{ AssignmentTypeText[AssignmentType.None] }}

                <a-tooltip
                  title="El resultado de la tipificación del usuario no afectará la asignación del contacto atendido. En futuras gestiones, el contacto será asignado aleatoriamente a otro usuario."
                >
                  <InfoCircleOutlined />
                </a-tooltip>
              </a-radio>

              <a-radio :value="AssignmentType.ContactDirect" :style="radioStyle">
                {{ AssignmentTypeText[AssignmentType.ContactDirect] }}

                <a-tooltip
                  title="El resultado de la tipificación del usuario no afectará la asignación del contacto atendido. En futuras gestiones, el contacto será asignado aleatoriamente a otro usuario."
                >
                  <InfoCircleOutlined />
                </a-tooltip>
              </a-radio>
            </a-radio-group>
          </a-form-item>

          <hr />

          <a-form-item
            name="contact_settings"
            label="Visualización de contactos para el rol agente"
          >
            <div class="group__info">
              <!-- <span>
                <InfoCircleOutlined />
              </span> -->
              <p class="info">
                Personaliza la forma en que los usuarios con rol de agente visualizan los contactos
                en su CRM para realizar búsquedas de personas específicas.
              </p>
            </div>

            <a-radio-group v-model:value="formState.contact_settings">
              <a-radio :value="1" :style="radioStyle">
                Todos los contactos de la campaña

                <a-tooltip
                  title="Los usuarios pueden ver y buscar en su CRM todos los contactos de sus campañas asignadas."
                >
                  <InfoCircleOutlined />
                </a-tooltip>
              </a-radio>

              <a-radio :value="2" :style="radioStyle">
                Únicamente contactos asignados

                <a-tooltip
                  title="Los usuarios pueden ver y buscar en su CRM únicamente los contactos asignados, ya sea por importación o gestión con tipificación de contacto directo (opción activada)."
                >
                  <InfoCircleOutlined />
                </a-tooltip>
              </a-radio>
            </a-radio-group>
          </a-form-item>

          <hr />
          <a-form-item name="contact_email" label="Gestión de correo electrónico">
            <div class="group__info">
              <!-- <span>
                <InfoCircleOutlined />
              </span> -->
              <p class="info">
                Selecciona los identificadores que estarán vinculados a tu campaña. Los usuarios
                asignados podrán visualizar su buzón de correo y asignarse correos.
              </p>
            </div>
            <div class="email_select">
              <p>Elige tus identificadores</p>
              <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="formState.channel_customer"
                mode="multiple"
                placeholder="Seleccionar identificadores"
                @change="handleChannelCustomerChange"
              >
                <a-select-option
                  v-for="option in identifierOptions?.filter(option => option.associate || option.alias)"
                  :key="option.id"
                  :value="option.id"
                >
                  <div class="option">
                    <p>{{ option.associate }}</p>
                    <span>{{ option.alias }}</span>
                  </div>
                </a-select-option>
              </a-select>
            </div>
          </a-form-item>
          <hr />

          <PortfolioIvrPicker
            v-model:sent-type="formState.survey_submission_type"
            v-model:ivr="formState.ivr"
            :radio-style="radioStyle"
          />

          <hr />

          <a-row :gutter="20">
            <a-col :span="24">
              <a-form-item name="voip_provider">
                <template #label> Troncal VOIP (Opcional) </template>
                <div class="group__info">
                  <p>Línea de comunicación que brindará acceso a la voz por internet.</p>
                </div>

                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.voip_provider"
                  placeholder="Seleccionar troncal"
                >
                  <a-select-option
                    v-for="trunk in trunks"
                    :key="trunk.id"
                    :disabled="!trunk.dialing_plans?.length"
                  >
                    {{ trunk.name }}
                    {{ trunk.dialing_plans?.length ? "" : " (Sin plan de marcación)" }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <hr />

          <div class="acw_flex_wrapper">
            <a-form-item name="is_enable_time_acw">
              <span class="title__strong">
                Habilitar temporizador ACW (Opcional)
                <a-switch v-model:checked="formState.is_enable_time_acw" size="small" />
              </span>
            </a-form-item>

            <a-form-item name="time_acw">
              <a-input-number
                v-model:value="formState.time_acw"
                :disabled="!formState.is_enable_time_acw"
                class="input-number"
                @input="showConfirmModal = true"
                :min="5"
                @change="handleMinValue"
              />
              <span> seg </span>
            </a-form-item>
          </div>

          <div class="group__info">
            <!-- <span>
              <InfoCircleOutlined />
            </span> -->
            <p class="info">
              Cantidad de tiempo restante para que un usuario complete su tipificación desde la
              finalización de la llamada.
            </p>
          </div>

          <a-form-item name="type_management">
            <a-radio-group v-model:value="formState.type_management" name="type_management">
              <a-radio
                :value="1"
                :style="radioStyle"
                :disabled="!formState.is_enable_time_acw"
                style="margin-bottom: 50px"
              >
                Guardar registro (log) por defecto
                <div class="register__defect">
                  <!-- <InfoCircleOutlined /> -->
                  <div class="info">
                    Por cada llamada realizada y que no haya sido tipificada dentro del máximo de
                    tiempo ACW, se guardarán datos como: Teléfono, agente, fecha y hora de la
                    gestión.
                  </div>
                </div>
              </a-radio>

              <a-radio
                :value="2"
                :style="radioStyle"
                :disabled="!formState.is_enable_time_acw"
                style="margin-bottom: 40px"
              >
                Seleccionar una tipificación por defecto
                <div class="register__defect">
                  <!-- <InfoCircleOutlined /> -->
                  <div class="info">
                    Deberás seleccionar una tipificación en la configuración de árbol de
                    tipificaciones para que se asigne automáticamente a cada llamada que supere el
                    máximo de ACW.
                  </div>
                </div>
              </a-radio>
            </a-radio-group>
          </a-form-item>

          <hr />

          <div class="acw_flex_wrapper">
            <a-form-item name="type_typification_call" required>
              <span class="title__strong">
                Botón guardar tipificación durante llamadas
              </span>
            </a-form-item>
          </div>

          <div class="group__info">
            <!-- <span>
              <InfoCircleOutlined />
            </span> -->
            <p class="info">
              Define el comportamiento del botón para guardar tipificaciones durante las llamadas.
            </p>
          </div>

          <a-form-item name="type_typification_call">
            <a-radio-group v-model:value="formState.type_typification_call" name="type_typification_call">
              <a-radio
                :value="1"
                :style="radioStyle"
                style="margin-bottom: 30px"
              >
                Guardar tipificación y terminar llamada
                <div class="register__defect">
                  <div class="info">
                    El sistema guardará los datos de la tipificación y finalizará la llamada en automático.
                  </div>
                </div>
              </a-radio>

              <a-radio
                :value="2"
                :style="radioStyle"
                style="margin-bottom: 40px"
              >
                Solo guardar tipificación
                <div class="register__defect">
                  <div class="info">
                    El sistema guardará los datos de la tipificación sin finalizar la llamada activa. Podrás continuar en la llamada con total normalidad.
                  </div>
                </div>
              </a-radio>
            </a-radio-group>
          </a-form-item>

          <hr />
          <div class="acw_flex_wrapper">
            <a-form-item name="enable_merge_tickets" required>
              <span class="title__strong">
                Unificar ticket activo de mensajería en llamada entrante
                <a-switch v-model:checked="formState.enable_merge_tickets" size="small" />
              </span>
            </a-form-item>
          </div>
          <div class="group__info">
            <p class="info">
              Cuando llegue una llamada, si el número ya tiene un ticket de mensajería activo entre las colas de <strong>esta misma campaña</strong>, este será consolidado en automático hacia el agente que reciba la llamada con todo el historial y contacto. De lo contrario, seguirá el flujo regular.
            </p>
          </div>
          <div class="acw_flex_wrapper">
            <a-form-item name="enable_queues_priority" required>
              <span class="title__strong">
                Prioridad de atención de llamadas por cola (Opcional)
                <p class="info"> Esta prioridad determina, si las llamadas en espera o por atender de esta cola serían atendidas con anticipación, cuando los agentes tienen llamadas en espera en otras colas.</p>
                <a-switch v-model:checked="formState.enable_queues_priority" size="small" />
              </span>
            </a-form-item>
          </div>
          <div class="group__info">
            <p class="info">
              Al activar esta configuración, podrás determinar si las llamadas en espera o por atender de las colas con más prioridad serán atendidas con anticipación.
              <strong> Recuerda que, al activar esta opción, la prioridad se configura al crear o editar las colas asociadas a esta campaña.</strong>
            </p>
          </div>
          <hr />
          <div class="acw_flex_wrapper">
            <a-form-item name="enable_calls_ringing" required>
              <span class="title__strong">
                Timbrado para las llamadas (Opcional)
                <a-switch v-model:checked="formState.enable_calls_ringing" size="small" @change="handleCallsRingingChange" />
              </span>
            </a-form-item>
          </div>
          <div class="group__info">
            <p class="info">
              Configura si las llamadas que se reciban, deben timbrar antes de ser atendidas por un usuario, en lugar de asignarse automáticamente.
            </p>
          </div>
          <a-form-item name="ringing_time" >
            <div class="group__item">
                <span class="required">*</span> Tiempo de timbrado 
                <a-tooltip>
                  <template #title v-if="!formState.enable_calls_ringing">
                    Indica el tiempo que timbrarán <br/>
                    las llamadas entrantes. Mínimo <br/>
                    5 segundos.                    
                  </template>  
                  <InfoCircleOutlined />: 
                </a-tooltip>
                <a-tooltip>  
                  <template #title v-if="!formState.enable_calls_ringing">
                    Es necesario activar el <br/>
                    timbrado para las llamadas
                  </template>                
                  <a-input-number
                    v-model:value="formState.ringing_time"
                    :disabled="!formState.enable_calls_ringing"
                    class="input-number"
                    :min="5"                    
                    @change="handleMinRingingValue"
                  />
                </a-tooltip>                
              segundos
            </div> 
          </a-form-item>

          <hr />
          <a-form-item label="Speech de apoyo para agentes (Opcional)">
            <div class="group__info">
              <p>
                Guión de conversación que visualizarán los agentes cuando se encuentren en una
                llamada.
              </p>
            </div>

            <QuillEditor
              ref="vueditor"
              contentType="html"
              :content="props.portfolio?.text_negotiation"
              @update:content="changeContentSpeech"
              theme="snow"
              toolbar="minimal"
              style="height: 8rem"
              placeholder="Escribir un speech"
            />
          <div class="actions">
            <div class="input_image">
              <InputActionButtons
                v-model:file="formState.media_negotiation"
                :file-name="props.portfolio?.filename"
                :has-media="true"
                :has-file="false"
                :has-emoji="false"
                :tooltip-media="
                  formState.media_negotiation ? 'Solo puedes adjuntar 1 imagen como máximo' : null
                "
              />
            </div>              
            <div class="counter">
              <span>{{ characterCount }} / {{ maxCharacters }}</span>
            </div>
          </div>
          </a-form-item>

          <hr />

          <a-form-item name="observations" label="Comentarios sobre la campaña (Opcional)">
            <div class="group__info">
              <p>
                Apartado para dar a conocer más sobre la campaña. Lo podrán visualizar los usuarios
                cuando se encuentren en Workspace.
              </p>
            </div>

            <a-textarea
              v-model:value="formState.observations"
              placeholder="Observaciones"
              rows="2"
              showCount
              :maxlength="1000"
            />
          </a-form-item>
        </a-form>
      </a-tab-pane>

      <!-- ScoreAI config -->
      <a-tab-pane :key="2" :disabled="!hasAIIntegration && [PlanType.AllInOne, PlanSpecial].includes(plan)">
        <template #tab>
          <a-tooltip>
            <template #title>
              Integre su API AI
            </template>
            {{ CompanyName }} AI
            <a-tag color="purple">All in One</a-tag>
          </a-tooltip>
        </template>
        <section class="score-ai">
          <p style="margin-bottom: 20px">
            Personaliza tu uso sobre {{ CompanyName }} AI en esta campaña. Para conocer mayor
            detalle sobre esta integración haz
            <RouterLink to="/integrations">click aquí.</RouterLink>
          </p>

          <a-form layout="vertical">
            <a-form-item label="Propósito" name="description">
              <p style="margin-bottom: 2px">
                Esto ayudará a la inteligencia artificial a conocer mejor el objetivo de tu campaña
                para las conclusiones que se generen.
              </p>

              <a-textarea
                v-model:value="formState.description"
                placeholder="Escribir aquí..."
                :autosize="{ minRows: 4, maxRows: 4 }"
                showCount
                :maxlength="1000"
              />
            </a-form-item>

            <a-form-item name="keywords">
              <template #label>
                <p style="font-weight: 400">
                  <span>Palabras o frases clave que describan el propósito de la campaña</span>
                  <a-tooltip title="Agrega nuevas palabras o frases haciendo click en “Enter”. ">
                    <InfoCircleOutlined style="margin-left: 5px" />
                  </a-tooltip>
                </p>
              </template>

              <a-select
                :getPopupContainer="(triggerNode: HTMLElement) => triggerNode.parentNode"
                v-model:value="formState.keywords"
                mode="tags"
                :token-separators="[',']"
                placeholder="Escribir aquí"
                :maxTagCount="20"
                @change="(value: string[]) => {
                  if (value.length > 20) {
                    formState.keywords = value.slice(0, 20);
                    $message.warning('Solo puedes agregar hasta 20 palabras o frases clave');
                  }
                }"
              />
            </a-form-item>

            <a-form-item name="enable_summary_agents">
              <template #label>
                <div class="enable-to-agents">
                  <span>Habilitar {{ CompanyName }} AI para agentes en Workspace</span>

                  <a-switch v-model:checked="formState.enable_summary_agents" size="small" />
                </div>
              </template>

              <p>
                Permitir que los usuarios con rol agente puedan generar conclusiones inteligentes
                desde el módulo de Workspace.
              </p>
            </a-form-item>
          </a-form>
        </section>
      </a-tab-pane>
    </a-tabs>

    <!--Fotter Modal -->
    <template #footer>
      <!-- :disabled="!portfolio?.customized_management && formState.type_default_management === 2" -->
      <a-button v-if="isEdit" @click="handleVerifyChanges"> Cancelar </a-button>
      <a-button
        v-if="isEdit ? false : formState.type_management === 2"
        :disabled="isSaveDisabled"
        :loading="loading"
        @click="handlePrimary({ goToTypification: true })"
      >
        Crear y continuar con tipificación
      </a-button>
      <a-tooltip>
        <template #title v-if="isSaveDisabled"> 
          Completa todos los campos requeridos para poder crear <br/> la campaña.
        </template>
        <a-button
          type="primary"
          id="create-portfolio"
          :disabled="isSaveDisabled"
          :loading="loading"
          @click="handlePrimary"
        >
          {{ isEdit ? "Guardar cambios" : "Crear campaña" }}
        </a-button>
      </a-tooltip>
    </template>
  </a-modal>

  <RestrictionChangePlanModal
    title="Realiza un upgrade y accede a todo el poder de Beex."
    v-model:open="openRestriction"
    :planRequest="PlanType.AllInOne"
  >
    <template #description>
      Tu plan {{ PlanTypeText[plan as PlanType] }} no incluye esta funcionalidad. <br/>
      Solicita un upgrade y potencia tu ambiente de trabajo. 
      ¡Que tu viaje no se detenga!
    </template>
  </RestrictionChangePlanModal>
</template>

<script setup lang="ts">
import { computed, createVNode, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import { Modal, message } from "ant-design-vue";
import { useRouter } from "vue-router";
import { InfoCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import { clone, isEqual } from "lodash";

import { Portfolio, UserData } from "@/@types/global";
import { EmailIdentifiers } from "@/@types/emails";
import { FormState, OperationType } from "@/@types/entities/portfolios";
// import { IdentifierType } from "@/@types/emails";
import { SentType } from "@/@types/ivr/sent";
import { TypeBusiness, TimeRingingDefault } from "@/app/shared/utils/enums";
import { AssignmentType, AssignmentTypeText } from "@/app/entities/utils/enums";
import { ResponseError } from "@/app/shared/utils/httpManager";

import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import PortfolioIvrPicker from "@/app/entities/components/picker/PortfolioIvrPicker.vue";
import { fetchAllChannelsCustomers } from "@/app/channels/services";
import { ChannelType } from "@/app/shared/utils/enums";
import { CompanyName } from "@/app/shared/utils/constants";
import InputActionButtons from "@/app/shared/components/buttons/InputActionButtons.vue";
import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import { ChannelPlan, ChannelPlanType, PlanType, PlanTypeText } from "@/app/common/types";

const props = defineProps<{ open: boolean; portfolio: Portfolio | undefined; isEdit: boolean }>();

const emit = defineEmits<{ update: []; "update:open": [open: boolean] }>();
const vueditorLastValue = ref();
const characterCount = ref(0);
const maxCharacters = 3000;
const radioStyle = {
  display: "flex",
  height: "30px",
  lineHeight: "30px",
};

const store = useStore();
const router = useRouter();

const openRestriction = ref(false);
const totalIdentifiers = ref<{ id: number; associate: string | null }[]>([]);
const totalIdentifiersValues = ref([]);

const activeTabKey = ref(1);
const identifierOptions = ref<EmailIdentifiers[]>();

const PlanSpecial = 5;

const title = computed(() => {
  console.log(props.isEdit, "form campaign edit");
  if (props.isEdit) return `Editar campaña "${props.portfolio?.name}"`;

  return "Crear campaña";
});

const plan = computed(() => {
  const user = store.getters["getDataUser"] as UserData;

  return user?.change_custom_plan?.plan;
});

const handleTabChange = (newKey: number) => {
  if (![PlanType.AllInOne, PlanSpecial].includes(plan.value) && newKey == 2) {
    openRestriction.value = true;
    return;
  }
  activeTabKey.value = newKey;
};

const getOperationType = (operationName: string | undefined) => {
  switch (operationName) {
    case "Atención al Cliente":
      return OperationType.ClientAttention;
    case "Telemarketing":
      return OperationType.Marketing;
    case "Televentas":
      return OperationType.Sells;
    case "Cobranzas":
      return OperationType.Collection;
    default:
      return OperationType.ClientAttention;
  }
};

const rules = computed(() => ({
  name: [{ required: true, message: "Campo requerido" }],
  entity: [{ required: true, message: "Campo requerido" }],
  schedule_management_type: [{ required: true, message: "Campo requerido" }],
  pdp_type: [
    { required: formState.operation_type === OperationType.Collection, message: "Campo requerido" },
  ],
  able_edit_client_negotiation: [],
  observations: [],
  is_enable_time_acw: [],
  time_acw: [{ required: true, message: "Campo requerido" }],
  is_enable_call_time: [],
  type_typification_call: [{ required: true, message: "Campo requerido" }],
  call_time: [{ required: true, message: "Campo requerido" }],
  enable_regeneration: [],
  operation_type: [{ required: true, message: "Campo requerido" }],
  enable_still_tipificactions: [{ required: true, message: "Campo requerido" }],
  channel_customer: [{ required: true, message: "Campo requerido" }],
}));

const vueditor = ref();

//Channel customer when isEdit
const channel_customer = computed(() =>
  Array.isArray(props?.portfolio?.channel_customer)
    ? props?.portfolio?.channel_customer.map(({ identifier }) => identifier)
    : []
);

const customerId = computed(() =>
  Array.isArray(props?.portfolio?.channel_customer)
    ? props?.portfolio?.channel_customer.map(({ id }) => id)
    : []
);

const handleCallsRingingChange = ()=> {
  if (!formState.enable_calls_ringing) {
    formState.ringing_time = 15;
  }
};

const handleMinValue = (value: any) => {
  if (value < 5) {
    formState.time_acw = 5;
  }
};

const handleMinRingingValue = (value: any) => {
  if (value < 5) {
    formState.ringing_time = 5;
  }
};

const handleChannelCustomerChange = (value: any) => {
  totalIdentifiersValues.value = value;
};

const formState: FormState = reactive({
  name: props.portfolio?.name || "",
  entity: props.portfolio?.entity.id || undefined,
  schedule_management_type: props.portfolio?.schedule_management_type || 1,
  pdp_type: props.portfolio?.pdp_type || 1,
  assignment_type: props.portfolio?.assignment_type || 1,
  contact_settings: props.portfolio?.contact_settings || 1,
  survey_submission_type: props.portfolio?.survey_submission_type || SentType.None,
  ivr: props.portfolio?.ivr || null,
  able_edit_client_negotiation: props.portfolio?.able_edit_client_negotiation || false,
  observations: props.portfolio?.observations || "",
  is_enable_time_acw: props.portfolio?.is_enable_time_acw || false,
  time_acw: props.portfolio?.time_acw || 5,
  is_enable_call_time: props.portfolio?.is_enable_call_time || false,
  call_time: props.portfolio?.call_time || 60,
  voip_provider: props.portfolio?.voip_provider || undefined,
  type_management: props.portfolio?.type_default_management || 1,
  operation_type: getOperationType(props.portfolio?.operation_type) || undefined,
  enable_regeneration: props.portfolio?.enable_regeneration || false,
  enable_still_tipificactions: props.portfolio?.enable_still_tipificactions || false,
  description: props.portfolio?.description || "",
  keywords: props.portfolio?.keywords || [],
  enable_summary_agents: props.portfolio?.enable_summary_agents || false,
  media_negotiation: props.portfolio?.media_url || "",
  // channel_customer: channel_customer.value || [],
  channel_customer: customerId.value || [],
  type_typification_call: props.portfolio?.save_management_and_finish_call == false ? 2 : 1,
  ringing_time: props.portfolio?.ringing_time || TimeRingingDefault,
  enable_queues_priority: props.portfolio?.enable_queues_priority || false,
  enable_calls_ringing: props.portfolio?.enable_calls_ringing || false,
  enable_merge_tickets: props.portfolio?.enable_merge_tickets || false,
});

const formStateToCompare = ref();

onMounted(async () => {
  await store.dispatch("fetchAllTrunks");

  formStateToCompare.value = clone(formState);

  await fetchAllEmailIdentifiers();
});

const trunks = computed(() => store.getters["getTrunkList"]);
const customer = computed(() => {
  const user = store.getters["getDataUser"] as UserData;

  return user.customer;
});
const hasAIIntegration = computed(() => {
  const user = store.getters["getDataUser"] as UserData;

  return user.customer_enable_summary;
});

const handleClose = () => emit("update:open", false);

const handleVerifyChanges = () => {
  const hasChanges = !isEqual(formState, formStateToCompare.value);

  if (!hasChanges) {
    handleClose();
    return;
  }

  Modal.confirm({
    title: "¿Deseas descartar los cambios realizados?",
    content: "Al cerrar no se guardarán los datos previamente ingresados",
    icon: createVNode(QuestionCircleOutlined),
    onOk: () => handleClose(),
    centered: true,
    okText: "Sí, descartar cambios",
    cancelText: "No, seguir editando",
  });
};

const isSaveDisabled = computed(() => {
  return !formState.name || !formState.entity || !formState.operation_type;
});

const formRef = ref();
const loading = ref(false);

const handlePrimary = async ({ goToTypification = false }) => {
  await formRef.value.validate();

  console.log(formState.channel_customer, "channel_customer");
  loading.value = true;

  try {
    const data = {
      ...formState,
      text_negotiation: vueditor.value.getHTML(),
      save_management_and_finish_call: formState.type_typification_call == 1,
    };

    if (props.isEdit) {
      await store.dispatch("updatePortfolioById", {
        portfolioId: props.portfolio?.id,
        portfolio: data,
      });
      message.success(`Se han guardado los cambios correctamente`);
    } else {
      const portfolio = await store.dispatch("createNewPortfolio", data);
      message.success(`Se ha creado la nueva campaña "${portfolio.name}"`);
      if (goToTypification) router.push(`/operations/campaigns/${portfolio.id}`);
    }

    emit("update");
    handleClose();
  } catch (error) {
    console.error(error);
    let errorMessage = "Ha ocurrido un error";
    if (error instanceof ResponseError) errorMessage = error.getErrorMessage();
    message.error(errorMessage);
  }

  loading.value = false;
};

const fetchAllEmailIdentifiers = async () => {
  const identifiers = await fetchAllChannelsCustomers(ChannelType.Email, null);

  const channelCustomer = props?.portfolio?.channel_customer ?? [];
  identifierOptions.value = [
    ...identifiers.filter(({ is_associate_portfolio }) => !is_associate_portfolio),
    ...channelCustomer.map((el) => ({ ...el, associate: el.identifier })),
  ].map(({ id, alias, associate }) => {
    return {
      id,
      associate,
      alias,
    };
  });

  const map = new Map();
  identifierOptions.value.forEach((item) => {
    map.set(item.id, item);
  });
  identifierOptions.value = [...map.values()];

  console.log(identifierOptions, "identifierOptions");
};

const changeContentSpeech = () => {
  const extractTextFromHTML = (html: string) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const plainText = extractTextFromHTML(vueditor.value.getHTML());
  characterCount.value = plainText.length;
  if (plainText.length > maxCharacters) {
    vueditor.value.setHTML(vueditorLastValue.value.getHTML());
  }
  const htmlContent = vueditor.value.getHTML();
  vueditorLastValue.value = {
    getHTML: () => htmlContent,
  };
};
</script>

<style scoped lang="sass">
p
  margin-bottom: 0

.form
  display: block
  margin: 0 auto
  padding: 0 10px
  height: 100%
  overflow-y: auto
  overflow-x: hidden
  scrollbar-width: thin
  scrollbar-color: #c1c1c1 transparent

  &::-webkit-scrollbar
    position: absolute
    width: 4px

  &::-webkit-scrollbar-track
    background: transparent

  &::-webkit-scrollbar-thumb
    background-color: #c1c1c1
    border-radius: 2px

.label
  font-weight: 600

  &__radio
    font-weight: normal

.ant-form-item
  margin-bottom: 5px

:deep(.ant-form-item-label)
  font-weight: 600

.small
  .ant-form-item
    margin-bottom: 4px
    margin-top: 20px

.input-number
  width: 50px

.checkbox
  margin-top: 6px

.separator
  margin-top: 8px

.container_info
  max-width: 80%
  color: $gray-8
  margin-left: 70px
  font-style: italic
  font-size: 12px
  display: flex
  align-items: baseline
  margin-bottom: 20px

.register__defect
  margin-left: 0
  margin-top: 0
  // font-style: italic
  font-size: 12px
  white-space: pre-line
  line-height: 20px
  display: flex
  align-items: baseline

.switch--small
  margin-bottom: 4px

.container__expire
  margin-bottom: 15px

.group__info
  color: $gray-8
  // font-style: italic
  font-size: 12px
  display: flex
  margin-bottom: 8px

.group__item
  display: flex
  align-items: center
  gap: 5px

.separator__radio
  white-space: pre-line
  line-height: 20px !important
  display: flex !important
  margin-top: 10px
  align-items: center !important
  margin-bottom: 10px

.separator__group
  margin-bottom: 20px

.form__error
  color: $red-6
  margin: 0

.required
  color: $red-4
  margin-right: 3px
  font-size: 12px !important

.acw_flex_wrapper
  display: flex
  justify-content: space-between
  align-items: center
  margin-top: 14px

.title
  &__strong
    font-weight: 600
    margin-right: 5px

  &__description
    color: $gray-9

.disabled
  color: rgba(0, 0, 0, 0.25)
  cursor: not-allowed

hr
  height: 1px
  background-color: $gray-4
  border: none
  margin-top: 16px
  margin-bottom: 16px

:deep(.ant-tabs-tabpane)
  padding: 10px 0
  height: max(60vh, 600px)

.score-ai
  p
    color: $text-primary

.enable-to-agents
  display: flex
  align-items: center
  gap: 16px
.email_select
  p
    margin-bottom: 5px
.actions
  display: flex
  justify-content: space-between
  align-items: center
.input_image
  display: flex
.counter
  margin-top: 8px
  font-size: 14px
  color: #555
  text-align: right
</style>
<style>
#form_item_contact_email_list ~ .rc-virtual-list .ant-select-item-option-content .option {
  display: flex;
  flex-direction: column-reverse;
}
</style>
